import React, { useState } from "react";
import { useGetStudentsOfParent } from "../../hooks/parentsHooks/useParents.hooks";
import { Parents } from "../../Models/parents.models";
import { getValue } from "../../utils/object.utils";
import { ItemDetailCard } from "../card/ItemDetailCard";
import { Card } from "../card";
import { TextBtnType } from "../Button/TextButton";
import { ConfirmationModalContainer } from "../Modal/ConfirmationModalContainer";
import { Colors } from "../../Constants/colors";
import { UserAvatar } from "../UserAvatar/UserAvatar";
import { useRemoveStudent } from "../../hooks/students/useRemoveStudent.hooks";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { SOMETHING_WENT_WRONG } from "../../Constants/messages";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../Constants/paths";
import { StudentNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import { FontSize } from "../../Constants/Enums/Size.enums";

interface Props {
  parent: Parents;
}
export const ParentStudent = ({ parent }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const parentId = getValue(parent, "id");
  const { data: students } = useGetStudentsOfParent({ parentId });

  const [seletedStudentToRemove, setSelectedStudentToRemove] = useState<
    any | null
  >(null);

  const { mutate: removeStudent } = useRemoveStudent({
    onSuccess: () => {
      setSelectedStudentToRemove(null);
      dispatch(setSuccessMessage("Student has been removed successfully."));
    },
    onError: (error: any) => {
      dispatch(
        setErrorMessage(error.response.data.message || SOMETHING_WENT_WRONG)
      );
    },
  });

  const onRemoveStudent = ({ studentId }: { studentId: number }) => {
    removeStudent({ studentId });
  };

  if (!(students || []).length) {
    // TODO -> Make a component for no data.
    return <div />;
  }
  return (
    <>
      <Card showCard={false}>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-8">
          {students.map((data: any) => {
            const transformedData = [
              {
                key: "Name",
                value: getValue(data, "full_name", ""),
              },
              {
                key: "Class",
                value: getValue(data, "class.class", ""),
              },
              {
                key: "School branch",
                value: getValue(data, "school_branch.name", ""),
              },
            ];
            return (
              <ItemDetailCard
                data={transformedData}
                avatar=""
                actions={[
                  {
                    title: "Edit",
                    onClick: () => {
                      navigate(
                        `${Paths.StudentDetails}?section=${StudentNavigationHeader.STUDENT_INFO}&studentId=${data.id}`
                      );
                    },
                    type: TextBtnType.primary,
                  },
                  {
                    title: "Remove",
                    onClick: () => {
                      setSelectedStudentToRemove(data);
                    },
                    type: TextBtnType.danger,
                  },
                ]}
              />
            );
          })}
        </div>
      </Card>
      <div className="flex flex-col gap-3" style={{ textAlign: "center" }}>
        <ConfirmationModalContainer
          show={!!seletedStudentToRemove}
          onClose={() => {
            setSelectedStudentToRemove(null);
          }}
          onSubmit={() => {
            onRemoveStudent({
              studentId: seletedStudentToRemove?.id,
            });
          }}
        >
          <UserAvatar image={seletedStudentToRemove?.avatar} />
          <div style={{ fontSize: FontSize.F14 }}>
            <p>
              This action will remove the{" "}
              <span style={{ color: Colors.BurgundyRed }}>
                {seletedStudentToRemove?.full_name || ""}'s{" "}
              </span>
              information.
            </p>
            <p>You wont be able to retrive this.</p>
          </div>
        </ConfirmationModalContainer>
      </div>
    </>
  );
};
